var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "font-sans antialiased text-gray-900 leading-normal tracking-wider content"
    },
    [
      _c(
        "div",
        {
          staticClass: "min-h-screen flex flex-col font-sans"
        },
        [
          _c(
            "div",
            {
              staticClass: "flex-grow"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "max-w-4xl h-auto flex items-center justify-center h-auto flex-wrap mx-auto my-28 lg:my-0"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-full lg:w-3/5 rounded-lg lg:rounded-lg shadow-2xl bg-white mx-6 lg:mx-0 my-16"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "p-4 md:p-12 text-center"
                        },
                        [
                          _vm._m(0),
                          _c("br"),
                          _vm.loading
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-2 mb-6"
                                },
                                [_c("preloader")],
                                1
                              )
                            : _vm.error
                            ? _c(
                                "p",
                                {
                                  staticClass: "mt-2 mb-6"
                                },
                                [_vm._v(_vm._s(_vm.error))]
                              )
                            : [
                                _vm.verified
                                  ? [
                                      _c(
                                        "h1",
                                        {
                                          staticClass:
                                            "text-3xl font-bold pt-8 lg:pt-0"
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "h-10 w-10 fill-current inline-block ggs-green pb-1",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 44 44"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "m22,0c-12.2,0-22,9.8-22,22s9.8,22 22,22 22-9.8 22-22-9.8-22-22-22zm12.7,15.1l0,0-16,16.6c-0.2,0.2-0.4,0.3-0.7,0.3-0.3,0-0.6-0.1-0.7-0.3l-7.8-8.4-.2-.2c-0.2-0.2-0.3-0.5-0.3-0.7s0.1-0.5 0.3-0.7l1.4-1.4c0.4-0.4 1-0.4 1.4,0l.1,.1 5.5,5.9c0.2,0.2 0.5,0.2 0.7,0l13.4-13.9h0.1c0.4-0.4 1-0.4 1.4,0l1.4,1.4c0.4,0.3 0.4,0.9 0,1.3z"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" Verified Green ")
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass:
                                          "mx-auto w-4/5 pt-1 border-b-2 border-green-600 opacity-75"
                                      })
                                    ]
                                  : [
                                      _c(
                                        "h1",
                                        {
                                          staticClass:
                                            "text-3xl font-bold pt-8 lg:pt-0"
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass:
                                                "h-10 w-10 fill-current inline-block text-red-500 pb-1",
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                viewBox: "0 0 51.976 51.976"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0\n    C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778\n    c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828\n    c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828\n    l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" Not Green ")
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass:
                                          "mx-auto w-4/5 pt-1 border-b-2 border-red-500 opacity-75"
                                      })
                                    ],
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "pt-2 font-bold lg:text-sm flex items-center justify-center"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "h-4 fill-current text-teal-700 pr-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 20 20"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm7.75-8a8.01 8.01 0 0 0 0-4h-3.82a28.81 28.81 0 0 1 0 4h3.82zm-.82 2h-3.22a14.44 14.44 0 0 1-.95 3.51A8.03 8.03 0 0 0 16.93 14zm-8.85-2h3.84a24.61 24.61 0 0 0 0-4H8.08a24.61 24.61 0 0 0 0 4zm.25 2c.41 2.4 1.13 4 1.67 4s1.26-1.6 1.67-4H8.33zm-6.08-2h3.82a28.81 28.81 0 0 1 0-4H2.25a8.01 8.01 0 0 0 0 4zm.82 2a8.03 8.03 0 0 0 4.17 3.51c-.42-.96-.74-2.16-.95-3.51H3.07zm13.86-8a8.03 8.03 0 0 0-4.17-3.51c.42.96.74 2.16.95 3.51h3.22zm-8.6 0h3.34c-.41-2.4-1.13-4-1.67-4S8.74 3.6 8.33 6zM3.07 6h3.22c.2-1.35.53-2.55.95-3.51A8.03 8.03 0 0 0 3.07 6z"
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "text-lg no-underline hover:no-underline",
                                        attrs: {
                                          href:
                                            "http://" + _vm.verification.domain
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.verification.domain))]
                                    )
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "pt-2 lg:text-sm flex items-center justify-center"
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "h-4 fill-current text-teal-700 pr-4",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          viewBox: "0 0 97.16 97.16"
                                        }
                                      },
                                      [
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M48.58,0C21.793,0,0,21.793,0,48.58s21.793,48.58,48.58,48.58s48.58-21.793,48.58-48.58S75.367,0,48.58,0z M48.58,86.823\n      c-21.087,0-38.244-17.155-38.244-38.243S27.493,10.337,48.58,10.337S86.824,27.492,86.824,48.58S69.667,86.823,48.58,86.823z"
                                          }
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d:
                                              "M73.898,47.08H52.066V20.83c0-2.209-1.791-4-4-4c-2.209,0-4,1.791-4,4v30.25c0,2.209,1.791,4,4,4h25.832\n      c2.209,0,4-1.791,4-4S76.107,47.08,73.898,47.08z"
                                          }
                                        })
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "text-lg"
                                      },
                                      [_vm._v(_vm._s(_vm.verification.time))]
                                    )
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.verified,
                                        expression: "!verified"
                                      }
                                    ],
                                    staticClass:
                                      "pt-4 font-bold text-gray-700 flex items-center justify-center mb-6"
                                  },
                                  [
                                    _vm._v(
                                      " This website is not verified using Green Hosting "
                                    )
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.verified,
                                        expression: "verified"
                                      }
                                    ],
                                    staticClass:
                                      "pt-4 font-bold text-gray-700 flex items-center justify-center mb-6"
                                  },
                                  [
                                    _vm._v(
                                      " This website is verified using Green Hosting "
                                    )
                                  ]
                                ),
                                _vm.verified
                                  ? _c(
                                      "p",
                                      {
                                        staticClass: "text-sm"
                                      },
                                      [
                                        _vm._v(
                                          " The Internet is a huge polluter of the environment. This website's carbon footprint is not offset, but reduced by using 300% Green Powered Web Hosting provided by "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "ggs-green",
                                            staticStyle: {
                                              "font-weight": "bold"
                                            },
                                            attrs: {
                                              href:
                                                "https://www.greengeeks.com",
                                              target: "new"
                                            }
                                          },
                                          [_vm._v("GreenGeeks")]
                                        ),
                                        _vm._v(". ")
                                      ]
                                    )
                                  : _c(
                                      "p",
                                      {
                                        staticClass: "text-sm"
                                      },
                                      [
                                        _vm._v(
                                          " The Internet is a huge polluter of the environment. This website's carbon footprint could be reduced by using 300% Green Powered Web Hosting provided by "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "ggs-green",
                                            staticStyle: {
                                              "font-weight": "bold"
                                            },
                                            attrs: {
                                              href:
                                                "https://www.greengeeks.com",
                                              target: "new"
                                            }
                                          },
                                          [_vm._v("GreenGeeks")]
                                        ),
                                        _vm._v(". ")
                                      ]
                                    ),
                                _vm._m(1)
                              ]
                        ],
                        2
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._m(2)
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "flex justify-center"
      },
      [
        _c(
          "a",
          {
            staticClass: "no-underline hover:no-underline",
            attrs: {
              href: "https://www.greengeeks.com/"
            }
          },
          [
            _c("img", {
              staticClass: "mb-6",
              attrs: {
                alt: "GreenGeeks logo",
                src: "/static/img/amui/logo_black.png"
              }
            })
          ]
        )
      ]
    )
  } /* staticRenderFnsSpliter */,
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "pt-6"
      },
      [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.greengeeks.com/going-green"
            }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "bg-green-600 hover:bg-teal-900 text-white font-bold py-2 px-4 rounded-full"
              },
              [_vm._v("Learn More")]
            )
          ]
        )
      ]
    )
  } /* staticRenderFnsSpliter */,
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c("div", [
      _c(
        "footer",
        {
          staticClass: "bg-white"
        },
        [
          _c(
            "div",
            {
              staticClass: "container max-w-4xl mx-auto my-28 lg:my-0 mx-auto"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex md:flex-row flex-col justify-around pt-6 text-center md:text-left"
                },
                [
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "uppercase text-gray-500 md:mb-6"
                      },
                      [_vm._v("Get Help")]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "list-reset mb-6"
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/kb"
                                }
                              },
                              [_vm._v("Knowledge Base")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/tutorials"
                                }
                              },
                              [_vm._v("Website Tutorials")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/support/"
                                }
                              },
                              [_vm._v("Support")]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "uppercase text-gray-500 md:mb-6"
                      },
                      [_vm._v("Services")]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "list-reset mb-6"
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/shared-hosting"
                                }
                              },
                              [_vm._v("Shared Hosting")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/reseller-hosting"
                                }
                              },
                              [_vm._v("Reseller Hosting")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/vps-hosting"
                                }
                              },
                              [_vm._v("VPS Hosting")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/dedicated-servers"
                                }
                              },
                              [_vm._v("Dedicated Servers")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/website-builder"
                                }
                              },
                              [_vm._v("Website Builder")]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "uppercase text-gray-500 md:mb-6"
                      },
                      [_vm._v("App Hosting")]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "list-reset mb-6"
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/wordpress-hosting"
                                }
                              },
                              [_vm._v(" WordPress Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/drupal-hosting"
                                }
                              },
                              [_vm._v(" Drupal Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/joomla-hosting"
                                }
                              },
                              [_vm._v(" Joomla Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/cpanel-hosting"
                                }
                              },
                              [_vm._v(" cPanel Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/cms-hosting"
                                }
                              },
                              [_vm._v(" CMS Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/magento-hosting"
                                }
                              },
                              [_vm._v(" Magento Hosting ")]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "uppercase text-gray-500 md:mb-6"
                      },
                      [_vm._v("Why GreenGeeks")]
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "list-reset mb-6"
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/platform"
                                }
                              },
                              [_vm._v(" Our Hosting Platform ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/going-green"
                                }
                              },
                              [_vm._v(" Why Green Hosting ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/about/greengeeks-reviews.php"
                                }
                              },
                              [_vm._v(" GreenGeeks Reviews ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/about/"
                                }
                              },
                              [_vm._v(" About The Company ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/affiliates"
                                }
                              },
                              [_vm._v(" Affiliate Program ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href:
                                    "https://www.greengeeks.com/about/service-guarantee.php"
                                }
                              },
                              [_vm._v(" Service Guarantees ")]
                            )
                          ]
                        ),
                        _c(
                          "li",
                          {
                            staticClass:
                              "mt-2 inline-block mr-2 md:block md:mr-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "no-underline hover:underline text-gray-800 hover:text-green-600",
                                attrs: {
                                  href: "https://www.greengeeks.com/about/"
                                }
                              },
                              [_vm._v(" About the company ")]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }